<template>
    <v-container>
        <v-layout>
            <v-flex md12>
                <v-card flat v-if="creditosSuficientes">
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Solicitud de Residencia</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-form v-model="valid" v-if="!cargandoDatos && !datosResidencia.capturada">
                            <span class="title">Datos Personales</span>
                            <v-container fluid grid-list-md>
                                <v-layout row wrap>
                                    <v-flex xs12 md6>
                                        <v-card transparent flat>
                                            <div class="subheading mb-3"><strong>Lugar</strong></div>
                                            <p>Tuxtla Gutiérrez</p>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-card transparent flat>
                                            <div class="subheading mb-3"><strong>Fecha</strong></div>
                                            <p>{{fechaActual}}</p>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-card transparent flat>
                                            <div class="subheading mb-3"><strong>Jefe de la División de Estudios Profesionales</strong></div>
                                            <p v-html="datosResidencia.jefe"></p>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-card transparent flat>
                                            <div class="subheading mb-3"><strong>Coordinador de la carrera</strong></div>
                                            <v-select
                                                    v-model="datosResidencia.proyecto.coordinador"
                                                    :items="datosResidencia.coordinadores"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    class="pt-0"
                                                    placeholder="Selecciona un coordinador"
                                                    :rules="[rules.required]"
                                                    required
                                            ></v-select>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <span class="title">Datos del Proyecto</span>
                            <v-container fluid grid-list-md>
                                <v-layout row wrap>
                                    <v-flex xs12 md12>
                                        <v-textarea
                                                v-model="datosResidencia.proyecto.nombre"
                                                label="Nombre del Proyecto"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="512"
                                                auto-grow
                                                rows="1"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-card transparent flat>
                                            <div class="subheading mb-3"><strong>Opción elegida *</strong></div>
                                            <v-radio-group
                                                    v-model="datosResidencia.proyecto.opcion"
                                                    :row="$mq !== 'sm'"
                                                    :rules="[rules.required]"
                                                    required
                                            >
                                                <v-radio
                                                        v-for="n in opcionesResidencia"
                                                        :key="n.id"
                                                        :value="n.id"
                                                        :label="n.name"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <div class="subheading mb-3"><strong>Periodo proyectado</strong></div>
                                        <p v-html="datosResidencia.periodo.nombre"></p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                                v-model="datosResidencia.proyecto.numeroResidentes"
                                                label="Número de Residentes"
                                                autocomplete="nope"
                                                type="number"
                                                :rules="[rules.required]"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <span class="title">Datos de la Empresa</span>
                            <v-container fluid grid-list-md>
                                <v-layout row wrap>
                                    <v-flex xs12 md8>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.nombre"
                                                label="Nombre de la Empresa"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="100"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.rfc"
                                                label="RFC"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="13"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-card transparent flat>
                                            <div class="subheading mb-3"><strong>Giro, Ramo o Sector *</strong></div>
                                            <v-radio-group
                                                    v-model="datosResidencia.empresa.giro"
                                                    :row="$mq !== 'sm'"
                                                    :rules="[rules.required]"
                                                    required
                                            >
                                                <v-radio
                                                        v-for="n in opcionesEmpresa"
                                                        :key="n.id"
                                                        :value="n.id"
                                                        :label="n.name"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-card>
                                    </v-flex>
                                    <v-flex xs10 md10>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.domicilio"
                                                label="Domicilio"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="100"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs2 md2>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.domicilioNumero"
                                                label="Número"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="25"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.colonia"
                                                label="Colonia"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="100"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.ciudad"
                                                label="Ciudad"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="50"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.codigoPostal"
                                                label="C.P."
                                                autocomplete="nope"
                                                type="number"
                                                :rules="[rules.required]"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.correo"
                                                label="Correo Electónico"
                                                :rules="[rules.email]"
                                                required
                                                counter
                                                maxlength="100"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.telefono"
                                                label="Teléfono"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="50"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.fax"
                                                label="Fax"
                                                mask="phone"
                                                autocomplete="nope"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md8>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.titular"
                                                label="Titular de la Empresa"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="50"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.puestoTitular"
                                                label="Puesto"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="50"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md8>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.asesorExterno"
                                                label="Asesor Externo"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="50"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.puestoAsesorExterno"
                                                label="Puesto"
                                                autocomplete="nope"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="50"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md8>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.intermediario"
                                                label="Nombre de la presona que firmará el acuerdo de trabajo"
                                                hint="Nombre de la presona que firmará el acuerdo de trabajo (Alumno-Escuela-Empresa)"
                                                autocomplete="nope"
                                                counter
                                                maxlength="50"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md4>
                                        <v-text-field
                                                v-model="datosResidencia.empresa.puestoIntermediario"
                                                label="Puesto"
                                                autocomplete="nope"
                                                counter
                                                maxlength="50"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <span class="title">Datos del Residente</span>
                            <v-container fluid grid-list-md>
                                <v-layout row wrap>
                                    <v-flex xs12 md3>
                                        <div class="subheading mb-3"><strong>No. de Control</strong></div>
                                        <p v-html="alumno.noDeControl"></p>
                                    </v-flex>
                                    <v-flex xs12 md9>
                                        <div class="subheading mb-3"><strong>Nombre</strong></div>
                                        <p v-html="alumno.nombreCompleto"></p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <div class="subheading mb-3"><strong>Carrera</strong></div>
                                        <p v-html="datosResidencia.carrera"></p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <div class="subheading mb-3"><strong>Domicilio</strong></div>
                                        <p v-html="datosResidencia.domicilio"></p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <div class="subheading mb-3"><strong>Teléfono</strong></div>
                                        <p v-html="datosResidencia.telefono"></p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <div class="subheading mb-3"><strong>Correo Eléctronico</strong></div>
                                        <p v-html="alumno.correoElectronico"></p>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <div class="subheading mb-3"><strong>Para la seguridad social acudir *</strong></div>
                                        <v-radio-group
                                                v-model="datosResidencia.alumno.seguro"
                                                :row="$mq !== 'sm'"
                                                :rules="[rules.required]"
                                                required
                                                counter
                                                maxlength="50"
                                        >
                                            <v-radio value="1" label="IMSS"></v-radio>
                                            <v-radio value="2" label="ISSSTE"></v-radio>
                                            <v-radio value="3" label="Otros"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs12 md12>
                                        <v-text-field
                                                v-model="datosResidencia.alumno.numeroSeguro"
                                                label="Número de seguro"
                                                :rules="[rules.required]"
                                                required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                        <v-progress-linear :indeterminate="true" v-if="cargandoDatos && !datosResidencia.capturada"></v-progress-linear>
                        <p v-if="datosResidencia.capturada">
                            Su solicitud de residencia se encuentra en proceso de revisión. <br>
                            <v-btn @click="descargar">Descargar la solicitud</v-btn>
                        </p>
                    </v-card-text>
                    <v-divider class="mt-5"></v-divider>
                    <v-card-actions v-if="!datosResidencia.capturada">
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                flat
                                @click="guardar"
                                :loading="guardarLoading"
                                :disabled="guardarLoading || !valid"
                        >Guardar</v-btn>
                    </v-card-actions>
                </v-card>
                <v-card v-else>
                    <v-card-title>
                        <div>
                            <h3 class="headline mb-0">Solicitud de Residencia</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        Aun no cumples con el 80% de créditos aprobados.
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import fileSaver from 'file-saver'
  import validator from 'validator'

  export default {
    name: 'ResidenciaProfesionalPage',
    data: () => ({
      guardarLoading: false,
      cargandoDatos: false,
      valid: false,
      opcionesResidencia: [
        { id: 1, name: 'Banco de proyectos' },
        { id: 2, name: 'Propuesta propia' },
        { id: 3, name: 'Trabajador' }
      ],
      opcionesEmpresa: [
        { id: 1, name: 'Industrial' },
        { id: 2, name: 'Servicios' },
        { id: 3, name: 'Público' },
        { id: 4, name: 'Privado' },
        { id: 5, name: 'Otro' }
      ],
      datosResidencia: {
        capturada: false,
        proyecto: {
          coordinador: '',
          nombre: '',
          opcion: 0,
          numeroResidentes: null
        },
        empresa: {
          nombre: '',
          rfc: '',
          giro: '',
          domicilio: '',
          colonia: '',
          ciudad: '',
          codigoPostal: null,
          telefono: null,
          fax: null,
          titular: null,
          puestoTitular: null,
          asesorExterno: null,
          puestoAsesorExterno: null,
          intermediario: null,
          puestoIntermediario: null,
          domicilioNumero: null,
          correo: null
        },
        alumno: {
          email: null,
          seguro: null,
          numeroSeguro: null
        },
        periodo: {
          id: '',
          nombre: ''
        }
      },
      rules: {
        required: (value) => !!value || 'Este dato es necesario.',
        email: (value) => {
          return validator.isEmail(value) || 'La dirección de correo es inválida.'
        }
      }
    }),
    computed: {
      ...mapState({
        alumno: state => state.user.profile,
        creditosSuficientes: state => {
          const avance = (state.user.profile.creditosAprobados * 100) / state.user.profile.creditosCarrera
          return avance >= 80
        }
      }),
      fechaActual: () => {
        let date = new Date()
        let options = {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }

        return date.toLocaleDateString('es-MX', options)
      }
    },
    methods: {
      cargarDatos () {
        this.cargandoDatos = true
        axios.get('alumno/solicitud-residencia')
          .then(resquest => {
            this.cargandoDatos = false
            this.datosResidencia = { ...this.datosResidencia, ...resquest.data }
          })
      },
      guardar () {
        this.guardarLoading = true
        axios.post('alumno/solicitud-residencia/save', this.datosResidencia)
          .then(response => {
            this.guardarLoading = false
            this.datosResidencia = response.data
            console.log('Guardado')
          })
          .catch(error => {
            console.log(error.data)
          })
          .finally(() => {
            this.guardarLoading = false
          })
      },
      descargar () {
        axios.get('alumno/solicitud-residencia/download', {responseType: 'arraybuffer'})
          .then(response => {
            const blob = new Blob([response.data], { type: response.headers['content-type'] })
            fileSaver.saveAs(blob, 'solicitud.pdf')
          })
      }
    },
    mounted () {
      if (this.creditosSuficientes) {
        this.cargarDatos()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/information/ResidenciaProfesionalPage.vue